// export const url = 'https://testapi.qlesseg.com/';// 'http://localhost:63181/'; //  'http://localhost:4300/'; // 
const defaultDomain =   'https://api.klickit.co/'; //  'http://localhost:63181/' ; //
export const domain = defaultDomain; //
//  'https://testback.qlesseg.com/'; //
export const apiUrlV1 = defaultDomain + 'api/v1/'; // 'http://localhost:63181/api/v1/'; //
